module.exports = __webpack_public_path__ + "media/images/admin/icons/layout-4d16993b5d384a25924ff8abf1bdc39d.svg";